// prettier-ignore

export const translationEN = {
  'acronym': 'JOPA',
  'magazine_title': 'Journal of Performing Arts ',
  'department_name': 'Department of Drama and Theatre Studies',
  'cavas_research_center': 'Advanced Research Centre for Studies in the Field of Performing Arts',
  'classification-1': 'Publication classified by CNCS in category "C", Theater and Performing Arts field.',
  'indexed-by': 'Publication indexed in:',
  'copyright': 'All rights reserved',
  affiliation: {
    'lucian_blaga_university_of_sibiu': 'Lucian Blaga University of Sibiu',
    'new_sorbonne_university_paris_3': 'New Sorbonne University Paris 3',
    'leeds_beckett_university': 'Leeds Beckett University',
    'hong_kong_metropolitan_university': 'Hong Kong Metropolitan University'
  },
  title: {
    'president': 'PRESIDENT',
    'editor_in_chief': 'EDITOR-IN-CHIEF',
    'associate_editor': 'ASSOCIATE EDITOR',
    'managing_editor': 'MANAGING EDITOR',
    'secretary': 'SECRETARY',
    'web_and_print': 'WEB & PRINT',
  },
  position: {
    'univ_professor': 'PhD Professor',
    'assoc_professor': 'PhD Lecturer',
    'phd_assoc_professor': 'PhD Associate Professor',
    'principal_lecturer': 'Principal Lecturer',
    'phd_student': 'PhD Student'
  },
  menu: {
    'about': 'About',
    'boards': 'Boards',
    'instructions': 'Instructions',
    'review': 'Review',
    'call_for_papers': 'Call For Papers',
    'archive': 'Archive',
    'contact': 'Contact',
  },
  publicationList: {
    title: 'Title',
    year: 'Issue year',
    download: 'Download',
  },
  pages: {
    index: {
      description: 'Journal of Performing Arts (JOPA) is an academic interdisciplinary and intercultural journal that is edited by Lucian Blaga University of Sibiu, through its Advanced Research Centre for Studies in the Field of Performing Arts. The journal covers aspects in the performing arts field of studies with a special focus on theatre, opera, dance, music, video, performance, film and also cultural management. JOPA publishes articles written by renowned artists and theoreticians and also encourages young and emergent scholars to submit their articles. The special aim of JOPA is to encourage the theoretical dissemination of the practical work in the case of specialists engaged in performing arts.',
      latest_release_authors: 'Topics featured by:',
      partnership: {
        'part1': 'This magazine is issued by',
        'part2': 'CENTER OF ADVANCED RESEARCH IN THE FIELD OF PERFORMING ARTS',
        'part3': 'in partnership with',
        'part4': 'RADU STANCA NATIONAL THEATRE OF SIBIU',
        'part5': 'SIBIU INTERNATIONAL THEATRE FESTIVAL',
        'part6': 'DRAMA AND THEATRE STUDIES DEPARTMENT, FACULTY OF LETTERS AND ARTS',
        'part7': 'LUCIAN BLAGA UNIVERSITY OF SIBIU',
        'part8': 'and',
        'part9': 'LUCIAN BLAGA UNIVERSITY OF SIBIU PUBLISHING HOUSE'
      }
    },
    boards: {
      'sicentific_board': 'Scientific Board',
      'walk_of_fame': 'Walk of Fame',
      'editorial_board': 'Editorial Board'
    },
    instructions: {
      'part1': 'In order to ensure a unitary structure, as well as the formal quality our magazines require, please be aware of the following drafting requirements.',
      'part2': 'The papers will be saved in .doc or .docx format.',
      'part3': 'Scientific studies / articles concerning the area of the performing arts, visual arts or cultural management (between 5 and 15 pages);',
      'part4': 'Analysis / scientific review of a performance or film (between 5 and 15 pages).',
      'part5': 'The texts will be written in Romanian, English or French and they will be complemented by an abstract (90-100 words) and 5 keywords in English.',
      'part6': 'The name of the author, as well as his/her degree and affiliation, will be written on the first row of the first page and it will be linked to a footnote containing a short bio of the author (activity, professional training and affiliation).',
      'part7': 'Under the title of the text written with Bold, which will be centrally fixed on the first page, the abstract, then the keywords, will be placed.',
      'part8': 'The texts will be written on page format A4, in Times New Roman, the font size 12, to 1.5 lines, Justify. All the edges of the page must be 2.5cm.',
      'part9': 'Quotes will be inserted between quotation marks and the source will be indicated in footnotes, respecting this formula: Name of the author, Book title in italic, Translator (if applicable), Publishing house, Place of publication, Year of publication, Page. E.g: Eugenio Barba, <i>Teatru: singurătate, meșteșug, revoltă</i>. Translated by Doina Condrea Derer, Nemira Publishing House, București, 2013, p. 136.',
      'part10': 'In the case of quotes for online sources, the footnote will specify the author’s name, the article’s title and also the link for the specific source, together with the date of access.',
      'part11': 'The papers must have, at the end, a bibliography in alphabetical order written as follows:',
      'part12': 'In the case of books: Last name of the author, First name of the author, Book title, Publishing house, Place of publication, Year of publication.',
      'part13': 'In the case of articles in newspapers or magazines: Last name of the author, First name of the author, Title of the article, Title of the magazine / newspaper, Number, Month of appearance, Place of appearance, Year of appearance.',
      'part14': 'In the case of WEB articles: Last name of the author, First name of the author, Title of the article, Link to the article, date of access.',
      'part15': 'Please send your papers to revista.jas@ulbsibiu.ro or andrei.serban@ulbsibiu.ro.'
    },
    review: {
      'part1': 'Journal of Performing Arts is a refereed journal.',
      'part2': 'All papers considered appropriate for this journal are reviewed anonymously by at least two outside reviewers. The reviewers are from different institution, not affiliated with the author’s institution.',
      'part3': 'The review process usually takes 4-6 weeks.',
    },
    call_for_papers: {
      'part1': 'Dear colleagues and collaborators,',
      'part2': 'We invite you to send your articles, studies and chronicles for the next Journal of Performing Arts issue (year {{year}}, no. {{issueNumber}}) until {{date}}.',
      'part3': 'For further information concerning the content and the features of the papers to be sent, please take a look at the Instructions for Authors section.',
    },
    archive: {
      'publishing': 'publishing',
    },
    contact: {
      'part1': 'Lucian Blaga University of Sibiu',
      'part2': 'Faculty of Letters and Arts',
      'part3': '5-7 Victoriei Blvd, 550024, Sibiu, Romania',
      'part4': 'revista.jas@ulbsibiu.ro',
      'part5': 'http://reviste.ulbsibiu.ro/jas',
      'part6': 'ion.tomus@ulbsibiu.ro',
      'part7': 'andrei.serban@ulbsibiu.ro'
    }
  },
  articles: {
    '2023/2-1': 'Ion ”Jimmy” Besoiu (1931-2017) - The Forgotten Years of Sibiu',
    '2023/2-2': 'Technology, Theatre, Society. Constructivism or Determinism?',
    '2023/2-3': 'VR Theatre: the paradox of Reality',
    '2023/2-4': 'The character Mask in the Context of Theatrical Pedagogy',
    '2023/2-5': 'Game and play. Acting and the Ludic Element of Generation Z',

    '2023/1-1': 'The First Editions of the Sibiu International Theatre Festival as Reected in Tribuna Newspaper (1993-1998)',
    '2023/1-2': 'Highlighting the Ancient Heritage – Between Its Cultural Potential and the Obligation to Protect It',
    '2023/1-3': 'Performing Arts in the Early Years of the First Festival Dedicated to Lucian Blaga (Sebe, 1981-1989)',
    '2023/1-4': 'The Semiotics and Physics of Gags',
    '2023/1-5': 'From Consciousness to Theatrical Performance. A Brief Foray Into the Theories of Contemporary Psychology',
    '2023/1-6': 'Means of Expressing an Artistic Message in Music and Performing Arts',
    '2023/1-7': 'Kinetic Art in the 20th Century. General Considerations',

    '2022/2-1': "The Culture Factory. Incorporating Technology on Stage",
    '2022/2-2': "'Satiricus' Theatre: Contemporary Dramaturgy as a Form of Resistance in the Republic of Moldova",
    '2022/2-3': "European borders, multicultural liminal spaces, and artistic resistance. How Sibiu International Theatre Festival exemplies a European heterotopic worksite for democracy",
    '2022/2-4': "The Festival: Origins and Significations. Civic Manifestations with Community Participation in Sibiu during the 16th Century",
    '2022/2-5': "The Hand, an Artistic Tool",
    '2022/2-6': "The Scarlet Princess. A Theatrical Journey between Europe and Japan",
    '2022/2-7': "The Eye Witness. Theatre Between Living on Stage Now and Memory",

    '2022/1-1': "The importance of imagination in acting",
    '2022/1-2': "The Villain: Ethos and Discourse. The Status and the Functions of the Sinner",
    '2022/1-3': "The relationship Between the Actor and the Spectator. Audience-groups of audience",
    '2022/1-4': "Hybrid tendencies in the theatrical public space: a multimodal analysis of the 'Forest of the Hanged', directed by Radu Afrim",
    '2022/1-5': "The Sound in Theatre",
    '2022/1-6': "Corporality and Gestures: Concepts and Ideas in the Teaching Methodologies of Russian Directors and Actors",
    '2022/1-7': "Mental Toughness for Athletes of the Voice",

    '2021/2-1': "Significations of Stage Representations: Mephisto in ‘Faust’ and ‘Midsummer Night’, directed by Silviu Pucărete",
    '2021/2-2': "Fashion shows: an atypical case of theatricality?",
    '2021/2-3': "Lars von Trier's Cinema – an Essay on Blindness",
    '2021/2-4': "Stage Directing of Musical Theatre: Multiculturalism, Visual Textures, East 'towards' West",
    '2021/2-5': "Harmony and Musicality in Mihai Eminescu's Poetry",
    '2021/2-6': "Tap Dance: Philosophy, Cultural Fusion and Nonverbal Communication",
    '2021/2-7': "Contemporary Theatricality – Dialogue between Presence and Challange",

    '2021/1-1': "THE THEATER WAS AN ART. NOW IT'S JUST A PROFESSION",
    '2021/1-2': "The Performance of the Restraints",
    '2021/1-3': "At Ghiță's Inn: Aspects of a synergic artistic concept, between traditional heritage and contemporary performing arts",
    '2021/1-4': "Technology. Theatre. Imagination",
    '2021/1-5': "Fighting Femininity: Radical Feminism and Woman-Hatred in Andrea Long Chu's Females and Valerie Solanas' Up Your Ass",
    '2021/1-6': "Lurking Shadows: Mental, Emotional and Physical Violence in Caryl Churchill's Far Away",
    '2021/1-7': "The Actor's World of Silence: Structural Significations and Artistic Impact of Silence in Theatre",
    '2021/1-8': "Romanian Cultural Institute. A Relevant International Revival",
    '2021/1-9': "Street Arts in Europe and their Audiences",
    '2021/1-10': "Techincal Production Management in Performing Arts",
    '2021/1-11': "The Value of Culture and the Evaluation of the Social Impact for the Cultural Organisations",

    '2020/2-1': "Isabelle Huppert in Dialogue with Cristian Mungiu",
    '2020/2-2': "Octavian Saiu in Dialogue with Alexandru Dabija and Radu Jude",
    '2020/2-3': "Irina Margareta Nistor in Dialogue with Maia Morgenstern",
    '2020/2-4': "Stabat Mater Furiosa. On the Musicality and the Need of the Words that Denounce",
    '2020/2-5': "From Active Art and Community Theatre to the Development of Social and Observational Theatre as a Method of Acting",
    '2020/2-6': "Monsters and Scissors. Edward Scissorhands, directed by Tim Burton: a short Analysis",
    '2020/2-7': "Eros and Biography in William Shakespeare's Sonnets",
    '2020/2-8': "Vocal Art, Pedagogy and Emotions Through Songs",

    '2020/1-1': "Theatre and the Spirit of the Times – Society, Arts and Politics",
    '2020/1-2': "Theatre and the Local Spirit – Theatre and the City",
    '2020/1-3': "Theatre and Borders – Exile of Theatre people: Leaving and returning",
    '2020/1-4': "George Banu in Dialogue with Wajdi Mouawad",
    '2020/1-5': "George Banu in Dialogue with Michèle Noiret",
    '2020/1-6': "Different Forms in Actors' Psychic Activity: Instincts, Sensations, Perceptions, Memories, Thought",
    '2020/1-7': "Ab initio. Mihai Pascaly and Matei Millo’s Itinerant Plays. The First Romanian Theatre Plays in Sibiu",

    '2019/2-1': "Editorial",
    '2019/2-2': "Shakespearean kings and Kiefer's books",
    '2019/2-3': "George Banu, Pippo Delbono",
    '2019/2-4': "George Banu, Emmanuel Demarcy-Mota",
    '2019/2-5': "Jean Michel Ribes, Matei Vișniec",
    '2019/2-6': "The absurdist theater in Japan. Waiting for Godot in Japan",
    '2019/2-7': "Horia Petra-Petrescu and the Theatre Journal (1913-1914)",
    '2019/2-8': "Playful spirit and the actor",
    '2019/2-9': "Stable or aggressive relationships between direction and musical style",
    '2019/2-10': "Preamble to the analysis of film language in Silviu Purcărete's work",

    '2019/1-1': "George Banu, Ioan Aurel Pop",
    '2019/1-2': "Stan Lai, Octavian Saiu",
    '2019/1-3': "George Banu, Eugenio Barba și Nicola Savarese",
    '2019/1-4': "The concept of theatricality. A critical reception",
    '2019/1-5': "General Considerations on the Sequel in Contemporary Culture and Performing Arts",
    '2019/1-6': "Thoughts for a possible future actor",
    '2019/1-7': "Inner constellations: Towards an analytical formalization of the actor's art",
    '2019/1-8': "Ritual and corporeality in the theatre of Koffi Kwahulé, Bintou",
    '2019/1-9': "Myth and logos in the work of Vasile Voiculescu",
    '2019/1-10': "The mystery of a mystery show",
    '2019/1-11': "Reality and realism in theatre and performing arts",

    '2015/2-1': "Theatre Actor - Film Actor: Impossible Choice",
    '2015/2-2': "Theatre and cultural policy in contemporary Europe",
    '2015/2-3': "Cultural treasures and rethinking them today",
    '2015/2-4': "Chinese dance on the world stage",
    '2015/2-5': "Fool's Night",
    '2015/2-6': "An acute evidence",
    '2015/2-7': "Between direction and narration: The portrayal of the dramatic character in Luigi Pirandello's didactic art",
    '2015/2-8': "Pianist or the object-man. Haneke and Jelinek: Between image and text",

    '2015/1-1': "Theatre is about meeting people",
    '2015/1-2': "Paradise Lost. In Africa and in Europe, with Brett Bailey, the Mesmerizer, in Charge",
    '2015/1-3': "Metanie to You, Father!",
    '2015/1-4': "Transcendental censorship and the meaning of Blagian tragedy",
    '2015/1-5': "Carmelo Bene's theatre. Stage text and musical approaches",
    '2015/1-6': "The theatrical space: Theoretical overview and terminological analysis",
    '2015/1-7': "Intersections with theatre in European experimental film",
    '2015/1-8': "WORK METHODS IN MODERN ACTING AND NON-FORMAL EDUCATION THEMES. COMEDY AGAINST VIOLENCE. SPIEGEL PROJECT",

    '2014/2-1': "Humanisation and stories through theatre",
    '2014/2-2': "What does contemporaneity mean in theatre?",
    '2014/2-3': "The Theatre of Sarah Kane. An Accursed Classic",
    '2014/2-4': "Unpacking Identity: Travelling Cases as Theatrical Props",
    '2014/2-5': "The monologue in the theater of Bernard-Marie Koltès",
    '2014/2-6': "'Cities on stage', intercultural dialogue through theatre projects",
    '2014/2-7': "Active art. A hypothesis",
    '2014/2-8': "The motif of the rout in Larry Tremblay's La Hache",
    '2014/2-9': "Bypassing dogmas: Lars von Trier. Dancer in the Dark",
    '2014/2-10': "Exile or banishment of the holy spirit",

    '2014/1-1': "About applause and its meaning",
    '2014/1-2': "A disappearing director: The experience of understanding classical texts",
    '2014/1-3': "Mozart Steps: About the intelligence of steps",
    '2014/1-4': "We are not in dialogue, we are a dialogue. Dialogue with George Banu",
    '2014/1-5': "The art and technique of the one-man show: Mr. and Brother Eminescule",
    '2014/1-6': "Theatrical reforms in contemporary opera. Olivier Messiaen. Saint François d'Assise",
    '2014/1-7': "Crime and Destiny in Ancient Tragedy",
    '2014/1-8': "The Suzuki Method and its fundamental principles",
    '2014/1-9': "Stage imagery architecture",
    '2014/1-10': "Imagination, a product of memory",
    '2014/1-11': "Change through theatre: Reality or utopia?",

    '2011/1-1': "The History of Modern and Contemporary Japanese Theatre – Personal Perspectives",
    '2011/1-2': "Contemporary Japanese Theatre. A Meeting with Masahiro Jasuda and His Company – Yamanote Jijosha",
    '2011/1-3': "QUESTIONS",
    '2011/1-4': "The Poetry Show. Case study: Evening Star",
    '2011/1-5': "Caricature and Naïve Art in Eugène Ionesco's Lesson",
    '2011/1-6': "The Sacred and the Profane – Central Motifs in Lucian Blaga's Plays",
    '2011/1-7': "The Beginnings of Theatre in Transylvania. The Middle Ages",
    '2011/1-8': "The Anthology of Plays Presented within the Play-Reading Programme – an Atypical Editorial Project",
    '2011/1-9': "I.L. Caragiale: Stage Interpretations in the Last Decades of the Twentieth Century",
    '2011/1-10': "Medea – The Metamorphoses of a Mythical Character",

    '2010/2-1': "A Theatre of Rupture",
    '2010/2-2': "About Mama and LaMaMa",
    '2010/2-3': "Bare-handed Theatre",
    '2010/2-4': "No Subtitles: the Clash of Dialects in 'Farewell Songs' by Hirata Oriza",
    '2010/2-5': "Folk Poetry, a Major Source for Performance",
    '2010/2-6': "The Tones of Metaphor or On Playing with Similarity",
    '2010/2-7': "The Character's Exile in Eugene Ionesco's Plays",
    '2010/2-8': "Excerpt from the BA Dissertation Entitled Death of the Character in Postmodern Theatre: The Death of the Character – a Trend in Postmodern Theatre. Case Study: Sarah Kane",
    '2010/2-9': "The Nude on Stage",
    '2010/2-10': "The Cinematographic Image in Theatrical Space",
    '2010/2-11': "I.L. Caragiale: Stage Interpretations in the Last Decades of the Twentieth Century",
    '2010/2-12': "Dramatizing I. L. Caragiale's Short Fiction",

    '2010/1-1': "What Has Become of the Avant-gardes of Yore?",
    '2010/1-2': "Eugene Ionesco – a Short History of Critical Reception",
    '2010/1-3': "The Bald Soprano: the Picturesque and the Naïve",
    '2010/1-4': "The Four Citadels of Art theatre",
    '2010/1-5': "The Death of the Character in Postmodern theatre. Case study: Rodrigo Garcia",
    '2010/1-6': "The Actor Facing the Impossibility of total Dissimulation",
    '2010/1-7': "A Discovery: Orestes by Euripides",
    '2010/1-8': "Folk Poetry, a Major Resource for Performance",
    '2010/1-9': "Ways of Achieving Expressiveness of Theatrical space in I. L. Caragiale's Comedies",
    '2010/1-10': "The Evolution of an Aesthetic Concept: the Grotesque",
    '2010/1-11': "The Novel and the Film: theoretical Approaches",

    '2009/1-1': "On Friendship",
    '2009/1-2': "The Poetry Show",
    '2009/1-3': "Chekhov and Caragiale: Four Narratives by I.L.Caragiale",
    '2009/1-4': "Aurel Manea: a Journal",
    '2009/1-5': "The Theatre and the Forms of Paradox (Towards an Aesthetics of Theatrical Art)",
    '2009/1/6': "An Interview with Matei Visniec",
    '2009/1-7': "Ways of Achieving Discursive Expressiveness in Caragiale's Comedies",
    '2009/1-8': "The Reign of the Image: Rehearsals for Andriy Zholdak's Turandot",
    '2009/1-9': "The 'Picturesque' and the 'Naive' in Vasile Alecsandri's Drama",
    '2009/1-10': "Jam Session Theatre – a Form of Detheatralized Theatre",
    '2009/1-11': "Pre-cinematic and Cinematic Elements in the Kabuki Theatre",
  }
}
